// © Copyright 2026 Emman Consulting SAS
import React from "react";
import { useDrag } from "@use-gesture/react";
import { TEAMS, sk } from "../../data/albumData.js";
import { I18N } from "../../i18n.js";
import FlagImg from "../ui/FlagImg.jsx";

export default function TeamModal({ tc, col, onTap, onReset, onDecrementDupe, onClose, lang }) {
  const td = TEAMS[tc];
  const t = I18N[lang];

  const stickers = [
    { n: "Logo del Equipo", sp: true },
    ...Array.from({ length: 11 }, (_, i) => ({ n: t.player + " " + (i + 2), sp: false })),
    { n: "Foto del Equipo", sp: true },
    ...Array.from({ length: 7 }, (_, i) => ({ n: t.player + " " + (i + 14), sp: false })),
  ];

  const oc = stickers.filter((_, i) => col[sk(tc, i + 1)]?.owned).length;

  const bind = useDrag(
    ({ down, movement: [, my], velocity: [, vy] }) => {
      const sheet = document.querySelector(".msheet");
      if (!down) {
        if (my > 160 && vy > 0.3) { onClose(); }
        else if (sheet) { sheet.style.transform = ""; sheet.style.opacity = ""; }
        return;
      }
      if (sheet) {
        sheet.style.transform = `translateY(${Math.max(0, my)}px)`;
        sheet.style.opacity = 1 - (my / 300);
      }
    },
    { from: () => [0, 0], filterTaps: true, threshold: 20, pointer: { touch: true }, axis: "y" }
  );

  if (!td) return null;

  return (
    <div className="movl" onClick={onClose}>
      <div className="msheet" onClick={(e) => e.stopPropagation()}>
        <div className="mhandle" {...bind()} />
        <div className="mhdr">
          <FlagImg cc={td.cc} className="mflag" />
          <div>
            <div className="mtname">{lang === "en" ? (td.en || td.n) : td.n}</div>
            <div className="mtcode">{tc}</div>
          </div>
          <div className="mprog">{oc}/20</div>
        </div>
        <div className="mbody">
          {stickers.map((s, i) => {
            const key = sk(tc, i + 1);
            const st = col[key] || { owned: false, quantity: 0 };
            const isDupe = st.owned && st.quantity > 0;
            return (
              <div key={key} className={"srow" + (isDupe ? " dupe" : st.owned ? " owned" : "")} onClick={() => onTap(key)}>
                <div className="srowl">
                  <div className="srowcode">{key}</div>
                  <div className="srown">
                    {s.sp && <span style={{ color: "#F5B800", marginRight: 4 }}>★</span>}
                    {s.n}
                  </div>
                </div>
                <div className="srowr">
                  {isDupe && <span className="dbadge">×{st.quantity}</span>}
                  {st.owned && (
                    <button
                      className="rstbtn"
                      onClick={(e) => {
                        e.stopPropagation();
                        st.quantity > 0 ? onDecrementDupe(key) : onReset(key);
                      }}
                    >×</button>
                  )}
                  <div className="chkc">{st.owned ? "✓" : ""}</div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}
